/* eslint-disable max-statements */
import { useEffect, useMemo, useState } from "react";
import { Button } from "react-bootstrap";
import PropTypes from "prop-types";
import { addSeconds } from "date-fns/esm";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { useTimer } from "react-timer-hook";

import Loader from "../../../components/Loader";
import { checkInAndGetLink } from "../services/joinCourseMutation";
import { timeToShowZoomLink } from "../../../helpers/event";
import { useNotifications } from "../../../components/NotificationsContext";

const MyAccountMyCourseJoin = ({
	course,
	registration
}) => {
	const { addNotification } = useNotifications();
	const [loading, setLoading] = useState(true);
	const [classLink, setClassLink] = useState(false);
	const navigate = useNavigate();
	const {
		restart,
		seconds
	} = useTimer({
		autoStart: false,
		onExpire: () => {
			if (classLink) {
				window.location.href = classLink;
			}
		}
	});

	const timeForLink = useMemo(() => timeToShowZoomLink(course), [course]);

	const {
		mutateAsync: getLink
	} = checkInAndGetLink(useMutation);

	useEffect(async () => {

		// eslint-disable-next-line no-constant-condition
		if (!timeForLink) {
			addNotification({
				message: "Video link not available yet.",
				type: "danger"
			});
			navigate(`/account/classes/${registration.courseId}`);
			return;
		}

		if (registration?.id) {
			try {
				const courseData = await getLink(registration.id);

				if (courseData.courselink) {
					const time = addSeconds(new Date(), 5);
					restart(time);

					setClassLink(courseData.courselink);
				} else {
					addNotification({
						message: "Error retrieving class link.",
						type: "danger"
					});
					navigate(`/account/classes/${registration.courseId}`);
				}
				setLoading(false);
			} catch (error) {
				addNotification({
					message: error.message,
					type: "danger"
				});
			}
		}
	}, [registration]);

	return loading
		? <Loader height="100%" width="100%" />
		: (
			<div className="text-center py-5">
				<h4 className="fw-bold">
					Redirecting you to &quot;{course.title}&quot; in {seconds} seconds...
				</h4>
				<p>If your browser does not redirect you automatically, please click the button below:</p>
				<Button href={classLink}>Go to Class</Button>
			</div>
		);
};

MyAccountMyCourseJoin.propTypes = {
	course: PropTypes.shape({
		title: PropTypes.string
	}).isRequired,
	registration: PropTypes.shape({
		id: PropTypes.number,
		courseId: PropTypes.number
	}).isRequired
};

export default MyAccountMyCourseJoin;
